import { render } from "./withdraw-submitted.vue?vue&type=template&id=44d00b88&scoped=true"
import script from "./withdraw-submitted.vue?vue&type=script&lang=js"
export * from "./withdraw-submitted.vue?vue&type=script&lang=js"

import "./withdraw-submitted.vue?vue&type=style&index=0&id=44d00b88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d00b88"]])

export default __exports__